<template>
  <div class="footer display-flex align-center">
    <div class="width-1200 display-flex align-center justify-between">
      <div class="display-flex align-center">
        <div class="footer-logo display-flex align-center">
          <img
            src="https://ali-file-cdn.iol8.com/img/logo/twinslator/logo-black-footer.png"
            width="100"
            height="24"
            alt=""
          />
        </div>
        <div class="footer-copyright padding-l-20 font-size-12">
          © 2012 - {{ new Date().getFullYear() }} TwinsMT All Right Reserved
          鄂ICP备13008893号-24
        </div>
      </div>
      <div class="footer-icon display-flex align-center">
        <img
          src="https://ali-file-cdn.iol8.com/img/logo/logo/pe-424-48.png"
          height="24"
          alt=""
        />
        <!--        <img src="../../images/pe-new.png" width="100" alt="" @click="goto('pe')"/>-->
        <!--        <img src="../../images/yzl-new.png" width="100" alt="" class="margin-l-20" @click="goto('yzl')"/>-->
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from 'vue'
  import { useRoute } from 'vue-router'

  export default defineComponent({
    setup() {
      const route = useRoute()

      const goto = (type) => {
        if (type == 'pe') {
          window.open(
            `${window.config.pe}?enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
            '_blank'
          )
        } else {
          window.open(window.config.wordpower, '_blank')
        }
      }
      const yzl = ref(0)
      const pe = ref(0)

      return {
        route,
        goto,
        yzl,
        pe,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    height: 56px;
    background: #fff;
    box-shadow: inset 0px 1px 0px 0px #f4f4f4;
    user-select: none;
    .footer-logo {
      span {
        color: #fff;
        font-size: 16px;
      }
    }
    .footer-copyright {
      font-size: 14px;
      color: #666;
      line-height: 20px;
      text-align: left;
    }
    .footer-icon {
      img {
        cursor: pointer;
      }
    }
  }
</style>
